import { configureTableColumns } from 'utils/table-helpers';
import { EndUsersColumns, useEndUsersTableColumns } from '../constants/endUsers-settings';
import useTable from 'hooks/useTable';

export const useController = () => {
    const filterSelectOptions = undefined;

    const { tableSettings } = useTable<EndUsersColumns>({
        columns: configureTableColumns(useEndUsersTableColumns(), filterSelectOptions || {}),
        queryIdentifier: 'endUsers',
        enableRowActions: false,
    });

    return {
        tableSettings,
    };
};

export default useController;
